import { AlertColor } from "@mui/material";
import { StateCreator } from "zustand";

export interface CustomAlertState {
    message: string;
    isOpen: boolean;
    severity: AlertColor;
    duration?: number;
}

export interface CustomAlertSlice {
    customAlert: CustomAlertState;
    setCustomAlert: (state: CustomAlertState) => void;
    showAlert: (message: string, severity: AlertColor, duration?: number) => void;
    closeAlert: () => void;
}

const initialCustomAlertState: CustomAlertState = { message: "", isOpen: false, severity: "info" };

export const createCustomAlertSlice: StateCreator<CustomAlertSlice, [], [], CustomAlertSlice> = (set) => ({
    customAlert: initialCustomAlertState,

    setCustomAlert: (state) => set({ customAlert: state }),
    showAlert: (message, severity, duration) => set({ customAlert: { isOpen: true, message, severity, duration } }),
    closeAlert: () => set({ customAlert: { isOpen: false, message: "", severity: "info" } }),
});

